import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/onboarding/employment')({
  component: () => <Navigate to='/onboarding' />,
})
